import { Injectable } from '@angular/core';
import { ChartOptions } from '@client/app/blocks/service/charts/base-chart/chart-factory';

@Injectable({
    providedIn: 'root',
})
export class LegendCursorService {
    constructor () { }

    setHoverState (options: ChartOptions): ChartOptions {
        const newOptions = options || {
            legend: {},
        };

        if (newOptions.legend) {
            newOptions.legend.onHover = (event: MouseEvent): void => {
                const target = event.target as HTMLElement;
                if (target?.style) {
                    target.style.cursor = 'pointer';
                }
            };

            newOptions.legend.onLeave = (event: MouseEvent): void => {
                const target = event.target as HTMLElement;
                if (target?.style) {
                    target.style.cursor = 'default';
                }
            };
        }
        return newOptions;
    }
}
